import axios from '@/libs/api.request'

/**
 * 孔附件列表
 */
export const workHoleAnnexList = (data_id) => {
    let data = {
        'data_id': data_id
    }
    return axios.request({
        url: '/api/admin/workhole/annexList',
        data,
        method: 'post'
    })
}

/**
 * 删除孔附件
 */
export const deleteWorkHoleAnnex = (id) => {
    let data = {
        'ids': id
    }
    return axios.request({
        url: '/api/admin/workhole/deleteAnnex',
        data,
        method: 'post'
    })
}

/**
 * 孔附件列表
 */
export const workHoleCheckAnnexList = (data_id) => {
    let data = {
        'data_id': data_id
    }
    return axios.request({
        url: '/api/admin/workholecheck/annexList',
        data,
        method: 'post'
    })
}

/**
 * 删除孔附件
 */
export const deleteWorkHoleCheckAnnex = (id) => {
    let data = {
        'ids': id
    }
    return axios.request({
        url: '/api/admin/workholecheck/deleteAnnex',
        data,
        method: 'post'
    })
}

/**
 * 打包下载物探成果
 */
export const downWtcg = (pid, ben, type) => {
    let data = {
        'pid': pid,
        'ben': ben,
        'type': type,
    }
    return axios.request({
        url: '/api/admin/wtcg/download',
        data,
        method: 'post'
    })
}

/**
 * 打包下载设计图纸
 */
export const downDesignDrawings = (pid, ben, type) => {
    let data = {
        'pid': pid,
        'ben': ben,
        'type': type,
    }
    return axios.request({
        url: '/api/admin/designdrawings/download',
        data,
        method: 'post'
    })
}

/**
 * 周月报附件列表
 */
export const monthReportAnnexList = (data_id) => {
    let data = {
        'data_id': data_id
    }
    return axios.request({
        url: '/api/admin/monthreport/annexList',
        data,
        method: 'post'
    })
}

/**
 * 删除周月报附件
 */
export const deleteMonthReportAnnex = (id) => {
    let data = {
        'ids': id
    }
    return axios.request({
        url: '/api/admin/monthreport/deleteAnnex',
        data,
        method: 'post'
    })
}

/**
 * 下载秒级数据文件
 */
 export const downMsgFile = (folder, fileName) => {
    let data = {
        'folder': folder,
        'fileName': fileName
    }
    return axios.request({
        url: '/api/admin/messagelog/downFile',
        data,
        method: 'post'
    })
}